<template>
  <v-dialog v-model="visible" max-height="500" max-width="700">
    <v-card>
      <v-toolbar dense color="gray" dark>
        <v-toolbar-title class="title" justify="center"
          >Neues Insekt</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="form-content">
        <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
          <v-row>
            <v-col cols="5">
              <label for="name:">Abkürzung</label>
              <v-text-field
                class="textFieldOne"
                outlined
                v-model="insect.abbreviation"
                :rules="rules.abbreviation"
                @input="abbreviationInput"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <label for="name:">Deutsch</label>
              <v-text-field
                class="textFieldTwo"
                outlined
                v-model="insect.germanName"
                :rules="rules.germanName"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <label for="name:">Latein</label>
              <v-text-field
                class="textFieldThree"
                outlined
                v-model="insect.latinName"
                :rules="rules.latinName"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-btn
              type="submit"
              class="emptyForm"
              style="margin-left:95px; max-width:360px; text-color:black;"
              :loading="isLoading"
              color="primary"
              :disabled="disableErstellen || !valid || isSubmitting"
              >Erstellen
            </v-btn>
            <v-btn
              type="button"
              class="emptyForm"
              style="margin-left:25px;"
              :loading="isLoading"
              color="gray"
              :disabled="!valid || isSubmitting"
              @click="resetFormAndCloseModal"
              >Abbrechen</v-btn
            >
          </v-row>
        </v-form>
        <v-alert
          type="success"
          elevation="20"
          v-show="showAlert"
          :color="alertColor"
          class="alert"
        >
          {{ alertText }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import UpdateInsect from "./UpdateInsect";

export default {
  props: {
    insect: {
      type: Object,
      default: () => ({
        id: null,
        abbreviation: "",
        germanName: "",
        latinName: ""
      })
    },
    visible: Boolean,
    itemList: Array
  },
  data() {
    return {
      disableErstellen: true,
      isLoading: false,
      dialog: false,
      showAlert: false,
      alertText: "",
      alertColor: "",
      rules: {
        abbreviation: [
          v =>
            (v && v.length <= 4) ||
            "Die Abkürzung darf höchstens 4 Zeichen umfassen",
          v =>
            (v && v.length >= 4) ||
            "Die Abkürzung muss mindestens 4 Zeichen enthalten"
        ],
        germanName: [v => !!v || "Deutscher Name ist erforderlich"]
      },
      valid: false
    };
  },
  computed: {
    formTitle() {
      return this.insect && this.insect.id
        ? "insect bearbeiten"
        : "Neue insect";
    },
    validForm() {
      return (
        !!this.insect.germanName &&
        !!this.insect.latinName &&
        !!this.insect.abbreviation
      );
    }
  },
  components: {
    UpdateInsect
  },
  methods: {
    abbreviationInput() {
      const inputValue = this.insect.abbreviation;

      if (inputValue.length == 4) {
        this.disableErstellen = false;
      } else {
        this.disableErstellen = true;
      }
    },
    closeModal() {
      this.$emit("close");
    },
    showUpdateDialog() {
      this.dialog = true;
    },
    submitForm() {
      this.isLoading = true;
      this.isSubmitting = true;

      const requestBody = {
        abbreviation: this.insect.abbreviation,
        germanName: this.insect.germanName,
        latinName: this.insect.latinName
      };

      if (!this.insect.id) {
        axios
          .post(
            "/api/InsectType/Create",
            requestBody
          )
          .then(response => {
            this.isLoading = false;
            if (Array.isArray(this.itemList)) {
              this.$set(this.itemList, this.itemList.length, response.data);
            } else {
              this.itemList = [response.data];
            }
            if (response.status === 200) {
              this.showAlert = true;
              this.alertColor = "success";
              this.alertText = "Das neue Insekt wurde erfolgreich erstellt";
              setTimeout(() => {
                this.closeModal();
                this.showAlert = false;
                this.resetForm();
                this.isSubmitting = false;
              }, 2000);
              this.$emit("updated-table", true);
            }
          })
          .catch(error => {
            console.log(error);
            this.isLoading = false;
            this.isSubmitting = false;
            if (error.response) {
              const errorCode = error.response.status;
              if (errorCode === 400) {
                // Bad request - handle validation errors
                const errorMessage = error.response.data.message;
                this.alertColor = "error";
                this.alertText = "Diese Abkürzung existiert bereits";
              } else {
                this.alertColor = "error";
                this.alertText = "Fehler beim Erstellen der Parasit";
              }
            } else {
              this.alertColor = "error";
              this.alertText = "Fehler beim Kommunizieren mit dem Server";
            }
            this.showAlert = true;
            setTimeout(() => {
              this.showAlert = false;
            }, 2000);
            this.resetForm();
          });
        // .catch(error => {
        //   console.log(error);
        //   this.isLoading = false;
        //   this.showAlert = true;
        //   this.alertColor = "error";
        //   this.alertText = "Fehler beim Erstellen der Insekt";
        //   setTimeout(() => {
        //     this.showAlert = false;
        //   }, 2000);
        // });
      }
    },
    resetForm() {
      this.$refs.form.reset();
      this.valid = true;
    },
    ///////////////////////////
    resetFormAndCloseModal() {
      this.resetForm();
      this.closeModal();
    }
  }
};
</script>
<style>
.alert {
  position: fixed !important;
  width: 100% !important;
  max-width: 784px !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  padding: 40px 100px !important;
}
.form-content {
  margin-top: 60px;
}
</style>
